import { render, staticRenderFns } from "./moments_topic.vue?vue&type=template&id=036e5d41"
import script from "./moments_topic.vue?vue&type=script&lang=js"
export * from "./moments_topic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports